import { Button, DatePicker, Form, Row, Space } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { buttonLabel, formConfig, placeHolders } from '../../../../constants';
import { getSubsidiaries } from '../../../../appRedux/actions';
import { CustomSelect } from '../../../uiComponents';
import { getBranchExpenses } from '../../../../appRedux/actions/Reports';

export const ExpensesByBranchFilter = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { subsidiaries } = useSelector((state) => state.subsidiary);

  useEffect(() => {
    dispatch(getSubsidiaries({ status: 1 }));
  }, [dispatch]);

  const onSubmit = (values) => {
    if (values?.month) {
      values.month = moment(values?.month).format('YYYY-MM');
    }

    dispatch(getBranchExpenses(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="month">
            <DatePicker picker="month" format={'YYYY-MM'} />
          </Form.Item>
          <Form.Item name="branchId">
            <CustomSelect
              placeholder={placeHolders.branch}
              style={{ minWidth: '200px' }}
              options={subsidiaries?.map(({ id, name }) => ({
                value: id,
                label: name,
              }))}
            ></CustomSelect>
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
